const LiveChat = (shop) => {
  window.__lc = window.__lc || {};
  window.__lc.license = 11930697;
  window.__lc.chat_between_groups = false; // this will create a new chat session between sites vidday, videogreet, helloworld
  ;(function (n, t, c) {
    function i(n) {
      return e._h ? e._h.apply(null, n) : e._q.push(n)
    }
    var e = {
      _q: [],
      _h: null,
      _v: '2.0',
      on: function () {
        i(['on', c.call(arguments)])
      },
      once: function () {
        i(['once', c.call(arguments)])
      },
      off: function () {
        i(['off', c.call(arguments)])
      },
      get: function () {
        if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.")
        return i(['get', c.call(arguments)])
      },
      call: function () {
        i(['call', c.call(arguments)])
      },
      init: function () {
        var n = t.createElement('script')
        ;(n.async = !0),
          (n.type = 'text/javascript'),
          (n.src = 'https://cdn.livechatinc.com/tracking.js'),
          t.head.appendChild(n)
      },
    }
    !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e)
  })(window, document, [].slice);

  const initLiveChat = () => {
    function checkWidget() {
      if(window.LC_API?.is_loaded() === false) {
        window.setTimeout(checkWidget, 1000);
      } else {
        LiveChatWidget.on("ready",()=>{
          $('#chat-widget-container').data('turbolinks','permanent');
          // var data = $('#chat-data').data();
          // var variables = {
          //   "VideoGreet - id": shop.id,
          //   "VideoGreet - Email": shop.email,
          //   "VideoGreet - Name": shop.shop_name,
          //   "VideoGreet - Domain": shop.shopify_domain,
          // }
          // LiveChatWidget.call('update_session_variables', variables);
          // Hide Live chat on viewing page
          if(document.location.href.indexOf('edit') > -1 || document.location.href.indexOf('get_started') > -1){
            LiveChatWidget.call('minimize');
          } else {
            LiveChatWidget.call('hide');
          }   
        });
      }
    }
    checkWidget();
	};
  
  initLiveChat();

};

export { LiveChat };